module.exports = __webpack_public_path__ + "static/Optimal-Retraction-Rate-d7d9bc8039d2e6f40b1ea6a99b00feac.png";